"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (element, _context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const { items } = element.value;
    const lines = [];
    lines.push('**Text Input Question**');
    lines.push('');
    items.forEach((item, index) => {
        const answer = item.label ? item.label.trim() : '';
        if (!answer) {
            return;
        }
        if (items.length > 1) {
            lines.push(`${index + 1}. Expected answer: **${answer}**`);
        }
        else {
            lines.push(`Expected answer: **${answer}**`);
        }
    });
    if (lines.length === 2) {
        return '';
    }
    return lines.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
